// it sets the spinner context state manually inside the axios interceptor, 
// cause hooks can not be used outside of the functional component 
const SpinnerContext = {
    contextHistory: null,
    asContext: (isDataLoading) => SpinnerContext?.contextHistory?.spinner?.setIsDataLoading(isDataLoading),
    // isDataLoading: () => { return SpinnerContext?.contextHistory?.spinner?.isDataLoading }
};

export default SpinnerContext;